<script>
import BefPlatformInfo from '@/pages/sign_info/components/BefPlatformInfo.vue'

export default {
  name: 'SignRecordTable',
  components: { BefPlatformInfo },
  props: {
    artistId: {
      type: String,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    detailMode: {
      type: Boolean,
      default: false
    },
    canViewRatio: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dataList: [],
      typeMap: { 'first': '首签', 'again': '二次签约', 'renewal': '续签' },
      dialogFormVisible: false,
      formData: {},
      platformOptions: []
    }
  },
  methods: {
    async getList() {
      this.dataList = []
      if (this.artistId) {
        const { list } = await this.$api.getKolSignList({ artist_id: this.artistId })
        this.dataList = list || []
      }

    },
    handleAdd() {
      this.formData = {}
      this.$set(this.formData, 'type', 'again')
      this.$set(this.formData, 'artist_id', this.artistId)
      this.$set(this.formData, 'contract_no', '')
      // this.formData['artist_id'] = this.artistId
      this.dialogFormVisible = true
    },
    handleDelete(row) {
      this.$confirm(`确认删除红人【${row.nickname}】的签约信息（仅删除本条签约记录，不删除红人数据）`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const info = await this.$api.deleteSignInfo(row.id)
        if (info) {
          // this.$notify.success('删除成功')
          await this.$alert('删除成功', '操作结果', {
            confirmButtonText: '确定',
            callback: () => {
              // 删除成功后只刷新签约记录列表（不再整页刷新）
              this.getList()
            }
          })
        } else {
          this.$notify.error('未知错误')
        }
      }).catch(() => {
        this.$notify.info('已取消')
      })
    },
    handleEdit(row) {
      this.formData = { ...row }
      // 签约开始日期统一规范化为 yyyy/MM/dd，与弹窗 date-picker 的 value-format 对齐，避免回显异常导致需先清空才能编辑
      this.$set(this.formData, 'sign_date', this.normalizeSignDate(row.sign_date))
      this.dialogFormVisible = true
    },
    normalizeSignDate(value) {
      if (value === null || value === undefined || value === '') return ''
      return String(value).split(' ')[0].replace(/-/g, '/')
    },
    async handleSave() {

      await this.$api.saveKolSignRecord(this.formData)
      if (this.formData.id) {
        await this.getList()
        this.dialogFormVisible = false
      } else {
        // 新增记录：保存后关闭弹窗并刷新签约记录列表（不再整页刷新）
        this.dialogFormVisible = false
        await this.getList()
      }
    },
    changePlatform(val) {
      const obj = this.platformOptions.find(value => value.code === val)
      this.formData.platform_name_aft = obj.name
    },
    displayContractNo(row) {
      return row.contract_no || row.contract_number || row.contract_code || row.contract_id || '-'
    },
    displayBloggerRatio(row) {
      if (!this.canViewRatio) {
        return '***'
      }
      const value = row.blogger_ratio
      return value === null || value === undefined || value === '' ? '-' : value
    },
    //获取
    getBefPlatformInfo(val) {
      this.formData.sign_bef_info = [...val]
      // console.log(this.dataForm.sign_bef_info)
    },
    async getPlatforms() {
      // 获取最新平台信息
      const { list } = await this.$api.getPlatforms()
      this.platformOptions = list
    }
  },

  mounted() {
    this.getList()
    this.getPlatforms()
  }

}
</script>

<template>
  <div>
    <div class='card-header theme-border' v-if='!detailMode'>
      <div></div>
      <div>
        <el-link @click='getList' style='font-size: 20px;font-weight: bolder'>签约记录</el-link>
      </div>
      <div v-if='isEdit'>
        <!--        <el-button type='primary' icon='el-icon-refresh' @click='getList'>刷新</el-button>-->
        <el-button type='primary' icon='el-icon-plus' @click='handleAdd'>添加签约记录</el-button>
      </div>
      <div v-else></div>
    </div>
    <el-table :data='dataList' stripe border>
      <el-table-column label='序号' type='index' align='center' width='60'></el-table-column>
      <!--      <el-table-column label='ID' prop='id' align='center' width='60'></el-table-column>-->
      <el-table-column label='签约类型' prop='type' align='center' width='100'>
        <template slot-scope='{row}'>
          <span :title='row.sign_status'>{{ typeMap[row.type] || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label='签约开始日期' prop='sign_date' align='center' min-width='120'></el-table-column>
      <el-table-column label='签约到期日期' prop='sign_end' align='center' min-width='120'></el-table-column>
      <el-table-column label='签约后主平台' prop='platform_name_aft' align='center' min-width='140'></el-table-column>
      <el-table-column label='合约性质' prop='nature_alias' align='center' min-width='120'></el-table-column>
      <el-table-column label='合约年限（年）' prop='term' align='center' min-width='120'></el-table-column>
      <el-table-column label='续约年限（年）' prop='renewal_years' align='center' min-width='120'></el-table-column>
      <el-table-column label='续约条件（万）' prop='renewal_cond' align='center' min-width='120'></el-table-column>
      <el-table-column label='博主分成比例（%）' prop='blogger_ratio' align='center' min-width='130'>
        <template slot-scope='{row}'>
          <span>{{ displayBloggerRatio(row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label='合同编号' prop='contract_no' align='center' min-width='160'>
        <template slot-scope='{row}'>
          <span>{{ displayContractNo(row) }}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column label='签约状态' prop='sign_status' align='center' min-width='100'></el-table-column>-->
      <!--      <el-table-column label='合同状态' prop='status' align='center' min-width='100'></el-table-column>-->
      <el-table-column label='操作' align='center' width='150' v-if='isEdit'>
        <template slot-scope='{row}'>
          <div class='action-row'>
            <el-button class='record-action-button' size='mini' plain icon='el-icon-edit' @click='handleEdit(row)'>编辑</el-button>
            <el-button class='record-action-button' size='mini' plain icon='el-icon-delete' @click='handleDelete(row)'>删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title='签约记录' center :visible.sync='dialogFormVisible' width='800px'>
      <el-form :model='formData' ref='ruleForm' label-width='140px' label-position='right' label-suffix='：'>
        <!--        <el-form-item label='红人昵称'>-->
        <!--          <span>{{ formData.nickname }}</span>-->
        <!--          &lt;!&ndash;          <el-input v-model='formData.nickname' placeholder='红人昵称' disabled></el-input>&ndash;&gt;-->
        <!--        </el-form-item>-->
        <el-form-item label='签约后主平台' required>
          <el-select v-model='formData.platform_code_aft' placeholder='选择 签约后平台' :clearable='true'
                     @change='changePlatform'>
            <el-option
              v-for='item in platformOptions'
              :key='item.code'
              :label='item.name'
              :value='item.code'>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='合约性质' required>
          <el-select v-model='formData.nature' placeholder='选择 合约性质' :clearable='true'>
            <el-option :label='`全约`' :value='1'>全约</el-option>
            <el-option :label='`商务约`' :value='2'>商务约</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='签约开始日期' required>
          <el-date-picker
            v-model='formData.sign_date'
            type='date'
            format='yyyy年MM月dd日'
            value-format='yyyy/MM/dd'
            placeholder='选择签约开始日期'>
          </el-date-picker>
          <!--          <el-input v-model='formData.sign_date' placeholder='签约开始日期'></el-input>-->
        </el-form-item>
        <el-form-item label='合约年限' required>
          <el-input v-model='formData.term' placeholder='本次续约的合约年限(来自上份合约)' clearable>
            <span slot='append'>年</span>
          </el-input>
        </el-form-item>
        <el-form-item label='续约年限'>
          <el-input v-model='formData.renewal_years' placeholder='下次续约的年限' clearable>
            <span slot='append'>年</span>
          </el-input>
        </el-form-item>
        <el-form-item label='续约条件（万）' required>
          <el-input v-model='formData.renewal_cond' placeholder='下次续约的条件' clearable></el-input>
        </el-form-item>
        <el-form-item label='博主分成比例' required>
          <el-input v-model='formData.blogger_ratio' placeholder='本次续约后的博主分成比例' clearable>
            <span slot='append'>%</span>
          </el-input>
        </el-form-item>
        <el-form-item label='合同编号'>
          <el-input v-model='formData.contract_no' placeholder='合同编号' clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button @click='dialogFormVisible = false'>取 消</el-button>
        <el-button type='primary' @click='handleSave'>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>
.card-panel {
  padding: 10px;
}

.card-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  border-bottom: #f2f2f2 1px solid;
  margin-bottom: 8px;
}

.action-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 4px;
}

.record-action-button {
  color: var(--primary);
}
</style>
